import React from "react";
import { Link } from "react-router-dom";

export const SectionTitle = ({ eyebrow, title, action, actionTo }) => (
  <div className="flex items-end justify-between px-4 sm:px-0 mb-4">
    <div>
      {eyebrow && <p className="text-xs uppercase tracking-[0.2em] text-[#D81B60] font-bold mb-1">{eyebrow}</p>}
      <h2 className="font-serif text-2xl sm:text-3xl text-[#2D0A22]">{title}</h2>
    </div>
    {action && actionTo && (
      <Link to={actionTo} className="text-sm font-semibold text-[#D81B60] hover:text-[#AD1457] underline underline-offset-4">
        {action}
      </Link>
    )}
  </div>
);
